module.exports = __webpack_public_path__ + "img/slack-image.bea02b82.png";